/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Sync_ExportableInputs */

const cs_tasks_sync_exportable = /** @type {(inputs: Tasks_Sync_ExportableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportovat do iCal / Google`)
};

const en_tasks_sync_exportable = /** @type {(inputs: Tasks_Sync_ExportableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export to iCal / Google`)
};

/**
* | output |
* | --- |
* | "Export to iCal / Google" |
*
* @param {Tasks_Sync_ExportableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_sync_exportable = /** @type {((inputs?: Tasks_Sync_ExportableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Sync_ExportableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_sync_exportable(inputs)
	return cs_tasks_sync_exportable(inputs)
});